/**
 * Alpha CVS note — when the Vibe Delivery cart widget turns 超商取貨 off for the
 * whole order (over the 5 / 10 kg chain limits, or a 不可超取 product), it explains
 * in a red box under the carrier list, which reads like "this order cannot ship"
 * even though 宅配 is selected and free. Here the same reason moves onto the
 * 超商 card and the red box is hidden.
 *
 * Alpha only: the Vibe Delivery app itself is untouched for other stores. The
 * orange 「… 仍可取貨」 notice (only some chains blocked) is left as it is.
 *
 * Also: the free-shipping bar says 「已達免運門檻」 with "$796 / $999" even when
 * the shipping is free because of a product rule (the 買2送1 / 買4送2 免運
 * bundles), not the $999 threshold. Free while under the threshold (or with no
 * threshold) can only be a rule, so say that instead and drop the totals.
 */
(function () {
  'use strict';

  var OFF_LABEL = '無法超商取貨';
  var RULE_FREE_LABEL = '此商品組合免運，運費 $0';

  var css =
    '.cvs-option.alpha-cvs-off{opacity:1!important}' +
    '.cvs-option.alpha-cvs-off .vd-shipping-icon,.cvs-option.alpha-cvs-off .vd-shipping-text{opacity:.45}' +
    '.cvs-option.alpha-cvs-off .vd-shipping-eta{display:block;margin-top:4px;color:#8a5a00;font-weight:500;line-height:1.35;white-space:normal;text-align:left}' +
    '.cvs-option.alpha-cvs-off .alpha-cvs-reason{display:inline-block;white-space:nowrap}' +
    '.cvs-ineligible-warning.alpha-cvs-moved{display:none!important}';
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  // Weight limits differ per chain (5 / 10 kg), so the widget prints one
  // near-identical reason each. Every chain is blocked here, so the highest
  // limit is the one that matters — one short line fits the narrow card.
  function noteFrom(body) {
    var re = /最多\s*([\d.]+)\s*公斤[^\d]*目前\s*([\d.]+)\s*公斤/g;
    var m, limits = [], current = null;
    while ((m = re.exec(body))) {
      limits.push(parseFloat(m[1]));
      current = parseFloat(m[2]);
    }
    if (limits.length) {
      var kg = function (n) { return String(Math.round(n * 10) / 10); };
      // Two unbreakable halves: the card wraps between them, never mid-word.
      return ['超過 ' + kg(Math.max.apply(null, limits)) + ' 公斤上限', '（目前 ' + kg(current) + ' 公斤）'];
    }
    return body.replace(/此訂單無法超商取貨，已改為宅配到家。?\s*$/, '').replace(/[；。\s]+$/, '').trim();
  }

  function setClass(el, name, on) {
    if (el.classList.contains(name) !== on) el.classList.toggle(name, on);
  }

  function money(s) { return parseFloat(String(s).replace(/,/g, '')); }

  function applyFreeShip(widget) {
    var bar = widget.querySelector('.vd-freeship.is-free');
    if (!bar || bar.hidden) return;
    var msg = bar.querySelector('.vd-freeship-msg');
    var goal = bar.querySelector('.vd-freeship-goal');
    if (!msg || !goal) return;
    if (msg.textContent === RULE_FREE_LABEL && goal.textContent === '') return;

    // Goal reads "$796 / $999" (cart total / threshold); empty when no threshold.
    var m = /\$\s*([\d,.]+)\s*\/\s*\$\s*([\d,.]+)/.exec(goal.textContent);
    var byRule = !m || money(m[1]) < money(m[2]);
    if (!byRule) return;
    msg.textContent = RULE_FREE_LABEL;
    goal.textContent = '';
  }

  function apply(widget) {
    applyFreeShip(widget);
    var box = widget.querySelector('.cvs-ineligible-warning');
    var card = widget.querySelector('.cvs-option');
    if (!box || !card) return;

    var cvsOff = card.disabled && box.classList.contains('is-stop') && box.style.display !== 'none';
    setClass(box, 'alpha-cvs-moved', cvsOff);
    setClass(card, 'alpha-cvs-off', cvsOff);
    if (!cvsOff) return;

    var bodyEl = widget.querySelector('[id^="cvs-ineligible-message-"]');
    var note = noteFrom(bodyEl ? bodyEl.textContent : '') || OFF_LABEL;
    var parts = Array.isArray(note) ? note : [note];
    var price = card.querySelector('.vd-shipping-price');
    var eta = card.querySelector('.vd-shipping-eta');
    if (price && price.textContent !== OFF_LABEL) {
      price.innerHTML = '<span class="vd-price-unavailable">' + OFF_LABEL + '</span>';
    }
    if (eta && eta.textContent !== parts.join('')) {
      eta.textContent = '';
      parts.forEach(function (text) {
        var span = document.createElement('span');
        span.className = 'alpha-cvs-reason';
        span.textContent = text;
        eta.appendChild(span);
      });
    }
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      document.querySelectorAll('[id^="vibe-delivery-container-"]').forEach(apply);
    });
  }

  new MutationObserver(schedule).observe(document.body, {
    subtree: true,
    childList: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['style', 'class', 'disabled']
  });
  schedule();
})();
